import { render, staticRenderFns } from "./SearchTableComponent.vue?vue&type=template&id=b2b1ad04&scoped=true"
import script from "./SearchTableComponent.vue?vue&type=script&lang=js"
export * from "./SearchTableComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchTableComponent.vue?vue&type=style&index=0&id=b2b1ad04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b1ad04",
  null
  
)

export default component.exports